export default function Credibility() {
  const stats = [
    { number: '3,200+', label: '累計実績', icon: 'ri-user-heart-line' },
    { number: '98.5%', label: '治療完了率', icon: 'ri-checkbox-circle-line' },
    { number: '9ヶ月', label: '平均治療期間', icon: 'ri-time-line' }
  ];

  const testimonials = [
    {
      name: '田中 美咲さん',
      age: '35歳',
      occupation: '営業職',
      image: 'https://public.readdy.ai/ai/img_res/e2ebabd5d1e7c592eb75b67a1c230584.jpg',
      comment: '営業の仕事で人前に出ることが多く、ずっと歯並びがコンプレックスでした。マウスピース矯正なら目立たないので、仕事中も安心。半年で見違えるほど綺麗になり、自信を持って笑えるようになりました。'
    },
    {
      name: '佐藤 恵子さん',
      age: '41歳',
      occupation: '主婦',
      image: 'https://readdy.ai/api/search-image?query=A%20warm%20friendly%20Japanese%20woman%20in%20her%20early%2040s%20with%20a%20gentle%20natural%20smile%20showing%20perfect%20teeth%2C%20casual%20elegant%20clothing%2C%20soft%20natural%20lighting%2C%20clean%20bright%20background%20in%20soft%20white%20and%20pink%20tones%2C%20maternal%20and%20kind%20expression%2C%20lifestyle%20portrait%20photography%20showing%20happiness&width=400&height=400&seq=testimonial-sato-keiko&orientation=squarish',
      comment: '子育てが落ち着いて、自分のために何かしたいと思い矯正を決意。痛みもほとんどなく、家事をしながらでも続けられました。夫からも「若返った」と言われて嬉しいです。'
    },
    {
      name: '山本 彩香さん',
      age: '29歳',
      occupation: '美容師',
      image: 'https://readdy.ai/api/search-image?query=A%20stylish%20trendy%20Japanese%20woman%20in%20her%20late%2020s%20with%20a%20bright%20cheerful%20smile%20showing%20beautiful%20teeth%2C%20fashionable%20modern%20outfit%2C%20bright%20natural%20lighting%2C%20clean%20contemporary%20background%20in%20soft%20teal%20tones%2C%20energetic%20and%20vibrant%20expression%2C%20professional%20lifestyle%20photography&width=400&height=400&seq=testimonial-yamamoto-ayaka&orientation=squarish',
      comment: '美容師という仕事柄、見た目には気を使っていましたが、歯並びだけは諦めていました。透明なマウスピースなら接客中も気にならず、お客様にも気づかれませんでした。今では笑顔に自信が持てます。'
    },
    {
      name: '高橋 由美さん',
      age: '45歳',
      occupation: '事務職',
      image: 'https://readdy.ai/api/search-image?query=A%20mature%20elegant%20Japanese%20woman%20in%20her%20mid%2040s%20with%20a%20sophisticated%20natural%20smile%20showing%20perfect%20white%20teeth%2C%20professional%20office%20attire%2C%20soft%20professional%20lighting%2C%20clean%20modern%20background%20in%20soft%20purple%20and%20white%20tones%2C%20confident%20and%20refined%20expression%2C%20high%20quality%20portrait%20photography&width=400&height=400&seq=testimonial-takahashi-yumi&orientation=squarish',
      comment: '40代で矯正を始めるのは遅いかと思いましたが、先生に「全然遅くない」と励まされました。治療後は写真を撮るのが楽しくなり、SNSにも笑顔の写真を載せられるようになりました。'
    }
  ];

  const features = [
    {
      title: '経験豊富な専門医',
      items: ['20年以上の矯正治療経験', '一人ひとりに合わせた治療計画', '最新の矯正技術を導入'],
      icon: 'ri-stethoscope-line',
      image: 'https://readdy.ai/api/search-image?query=A%20professional%20Japanese%20dentist%20examining%20patient%20with%20advanced%203D%20dental%20scanner%20in%20modern%20clinic%2C%20bright%20professional%20lighting%2C%20state-of-the-art%20dental%20equipment%20and%20technology%2C%20clean%20modern%20clinic%20interior%2C%20professional%20medical%20photography%20showing%20expertise&width=600&height=400&seq=feature-1&orientation=landscape'
    },
    {
      title: '充実のアフターケア',
      items: ['24時間LINE相談対応', '定期チェック無料', '3年間の保証制度'],
      icon: 'ri-customer-service-2-line',
      image: 'https://readdy.ai/api/search-image?query=A%20caring%20dental%20staff%20member%20providing%20follow-up%20consultation%20to%20a%20smiling%20Japanese%20female%20patient%20in%20a%20comfortable%20modern%20clinic%20room%2C%20soft%20professional%20lighting%2C%20warm%20and%20welcoming%20clinic%20interior%2C%20professional%20healthcare%20photography%20showing%20support%20and%20care&width=600&height=400&seq=feature-2&orientation=landscape'
    }
  ];

  return (
    <section id="credibility" className="py-20 bg-gradient-to-br from-teal-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            多くの患者様に<br />
            <span className="text-teal-600">選ばれています</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            確かな実績と信頼のサポート体制
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-20">
          {stats.map((stat, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg text-center hover:shadow-2xl transition-all duration-300">
              <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
                <i className={`${stat.icon} text-3xl text-teal-600`}></i>
              </div>
              <div className="text-5xl font-bold text-teal-600 mb-2">{stat.number}</div>
              <div className="text-gray-600 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="mb-20">
          <h3 className="text-3xl font-bold text-gray-900 text-center mb-12">患者様の声</h3>
          <div className="grid md:grid-cols-2 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300">
                <div className="flex items-start gap-6 mb-6">
                  <div className="relative flex-shrink-0">
                    <img 
                      src={testimonial.image} 
                      alt={testimonial.name} 
                      className="w-20 h-20 rounded-full object-cover object-top"
                    />
                    <div className="absolute -bottom-2 -right-2 w-8 h-8 flex items-center justify-center bg-teal-500 rounded-full">
                      <i className="ri-check-line text-white text-lg"></i>
                    </div>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-1 mb-2">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                      ))}
                    </div>
                    <h4 className="font-bold text-gray-900 text-lg">{testimonial.name}</h4>
                    <p className="text-sm text-gray-500">{testimonial.age}歳 / {testimonial.occupation}</p>
                  </div>
                </div>
                <p className="text-gray-700 leading-relaxed">{testimonial.comment}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={feature.image} 
                  alt={feature.title} 
                  className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-br from-teal-500 to-cyan-500 opacity-10"></div>
              </div>
              <div className="p-8">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full">
                    <i className={`${feature.icon} text-2xl text-teal-600`}></i>
                  </div>
                  <h4 className="text-2xl font-bold text-gray-900">{feature.title}</h4>
                </div>
                <ul className="space-y-3">
                  {feature.items.map((item, idx) => (
                    <li key={idx} className="flex items-center gap-3">
                      <i className="ri-check-line text-teal-600 text-xl"></i>
                      <span className="text-gray-700">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}